var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ShortCourse"},[_c('div',{staticClass:"titlePage"},[_vm._v("Reporte de Cursos Cortos")])])
}]

export { render, staticRenderFns }